import type { MyIcon } from '@repo/icons';

interface Props {
  flag: MyIcon;
  text: string;
}

const FLAG_HEIGHT = 16;

export default function LanguageOptionLabel({ flag, text }: Props) {
  const Flag = flag;

  return (
    <span className="flex items-center gap-2">
      <span className="overflow-hidden rounded-md">
        <Flag size={FLAG_HEIGHT} />
      </span>
      {text}
    </span>
  );
}
